import React, { useState } from 'react';
import './App.css';

function App() {
  const [url, setUrl] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const checkFraud = async () => {
    if (!url) return;
    
    setLoading(true);
    try {
      // This is a placeholder for the actual fraud detection API
      // You would replace this with your actual API call
      setTimeout(() => {
        setResult({
          isFraud: Math.random() > 0.5,
          confidence: Math.floor(Math.random() * 100),
          message: "This is a demo result. Replace with actual API integration."
        });
        setLoading(false);
      }, 1500);
    } catch (error) {
      console.error('Error checking fraud:', error);
      setLoading(false);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>FraudHunter AI</h1>
        <p>Cek Penipuan - Aplikasi cerdas untuk mendeteksi berita penipuan dan reputasi perusahaan.</p>
      </header>
      
      <main className="App-main">
        <div className="check-container">
          <h2>Periksa URL atau Konten</h2>
          <div className="input-group">
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Masukkan URL atau teks yang ingin diperiksa"
              className="url-input"
            />
            <button 
              onClick={checkFraud} 
              disabled={loading || !url}
              className="check-button"
            >
              {loading ? 'Memeriksa...' : 'Periksa'}
            </button>
          </div>
          
          {result && (
            <div className={`result ${result.isFraud ? 'fraud' : 'safe'}`}>
              <h3>Hasil Pemeriksaan:</h3>
              <p className="result-message">{result.message}</p>
              <div className="result-details">
                <p>Status: <strong>{result.isFraud ? 'Berpotensi Penipuan' : 'Aman'}</strong></p>
                <p>Tingkat Kepercayaan: <strong>{result.confidence}%</strong></p>
              </div>
            </div>
          )}
        </div>
      </main>
      
      <footer className="App-footer">
        <p>&copy; 2025 FraudHunter AI. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;